import { devError } from '@/utils/logger'

export interface ErrorContext {
  /** Where it happened, e.g. 'reservations.create'. */
  readonly scope?: string
  /** Extra non-sensitive detail. NEVER put card data, tokens or PII here. */
  readonly extra?: Readonly<Record<string, unknown>>
}

/**
 * The single entry point for reporting a caught error.
 *
 * In dev it logs. In production it forwards to the error tracker through the
 * lazy facade in `src/lib/sentry.ts` — which is only ever loaded via dynamic
 * import, so the SDK never enters the main bundle.
 */
export function reportError(error: unknown, context: ErrorContext = {}): void {
  devError(`[${context.scope ?? 'app'}]`, error, context.extra ?? {})

  if (import.meta.env.DEV) return

  void import('@/lib/sentry')
    .then((sentry) => sentry.captureError(error, context))
    .catch(() => {
      /* never let error reporting break the app */
    })
}
